import type { MessagesTranslations } from "../../types/messages";

export const messages: MessagesTranslations = {
  title: "Message Board",
  composerPlaceholder: "Write a message…",
  send: "Send",
  sendFailed: "Couldn't send your message. It's back in the box — please try again.",
  reply: "Reply",
  replyingTo: "Replying to {name}",
  cancelReply: "Cancel reply",
  edit: "Edit",
  delete: "Delete",
  edited: "Edited",
  deletedNote: "Deleted message",
  deletedQuote: "Message unavailable",
  today: "Today",
  yesterday: "Yesterday",
  emptyChannel: "No messages yet — start the conversation.",
  noProjects: "No projects yet",
  noProjectsHint: "Create a project for this building to start messaging.",
  attach: "Attach a file",
  mention: "Mention someone",
  addReaction: "Add reaction",
  expand: "Expand",
  confirmDelete: "Delete this message?",
  confirmDeleteDescription: "This message will be removed for everyone. This can't be undone.",
  channelsHeading: "Projects",
  selectChannel: "Select project channel",
  unreadBadge: "{count} new",
};
